import HeroSection from "../components/HeroSection";
import ARPChatSection from "../components/ARPChatSection";
import ARPMobileSection from "../components/ARPMobileSection";
import PlansSection from "../components/PlansSection";
import SVAsSection from "../components/SVAsSection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <main className="overflow-x-hidden bg-brand-charcoal">
      <HeroSection />
      <ARPChatSection />
      <ARPMobileSection />
      <PlansSection />
      <SVAsSection />
      <Footer />
    </main>
  );
};

export default HomePage;
